/** Short relative times for thread lists: "now", "5m", "3h", "2d". */
export const relativeTime = (
  iso: string | null | undefined,
  now: number = Date.now()
): string => {
  if (!iso) return "";
  const stamp = new Date(iso).getTime();
  if (Number.isNaN(stamp)) return "";
  const m = Math.round((now - stamp) / 60000);
  if (m < 1) return "now";
  if (m < 60) return `${m}m`;
  const h = Math.round(m / 60);
  if (h < 24) return `${h}h`;
  const d = Math.round(h / 24);
  if (d < 30) return `${d}d`;
  const mo = Math.round(d / 30);
  if (mo < 12) return `${mo}mo`;
  return `${Math.round(mo / 12)}y`;
};

export type RecencyBucket = "today" | "yesterday" | "week" | "older";

export const RECENCY_LABEL: Record<RecencyBucket, string> = {
  today: "Today",
  yesterday: "Yesterday",
  week: "Last 7 days",
  older: "Older"
};

const startOfDay = (ms: number): number => {
  const d = new Date(ms);
  d.setHours(0, 0, 0, 0);
  return d.getTime();
};

/** Which "Recent chats" group a timestamp belongs to. */
export const recencyBucket = (
  iso: string | null | undefined,
  now: number = Date.now()
): RecencyBucket => {
  if (!iso) return "older";
  const stamp = new Date(iso).getTime();
  if (Number.isNaN(stamp)) return "older";
  const today = startOfDay(now);
  const day = 24 * 60 * 60 * 1000;
  if (stamp >= today) return "today";
  if (stamp >= today - day) return "yesterday";
  if (stamp >= today - 6 * day) return "week";
  return "older";
};
